import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';
import {
    EditorModule, TabViewModule,
    CalendarModule, DataTableModule, MenubarModule, ConfirmDialogModule, ConfirmationService
} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { DomSanitizer } from '@angular/platform-browser';

import { EntityDetailsComponent } from 'app/entities/details/entity-details.component';
import { EntityDetailsClientComponent } from 'app/entities/details/entitydetailsclient/entity-details-client.component';
import { EntityDetailsOrgComponent } from 'app/entities/details/entitydetailsorg/entity-details-org.component';
import { EntityDetailsPersonComponent } from 'app/entities/details/entitydetailsperson/entity-details-person.component';
import { AddServiceComponent } from 'app/entities/details/services/addservices/add-service.component';
import { EditServicesDescriptionComponent } from 'app/entities/details/services/editdescription/edit-description.component';
import { ClientServicesComponent } from 'app/entities/details/services/client-services.component';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { ClientServicesService } from 'app/entities/details/services/client-services.service';
import { ContactService } from 'app/entities/details/contactinformation/contact.service';
import { AddressInformationComponent } from 'app/entities/details/addressinformation/address-information.component';
import { ContactInformationComponent } from 'app/entities/details/contactinformation/contact-information.component';
import {
    AddContactInformationComponent
} from 'app/entities/details/contactinformation/addcontactinformation/addcontactinformation.component';
import { AddressInformationService } from 'app/entities/details/addressinformation/address-information.service';
import { AddAddressComponent } from 'app/entities/details/addressinformation/addaddress/add-address.component';
import { GeneralInformationComponent } from './generalinformation/general-information.component';
import { UpdateGeneralInfoComponent } from 'app/entities/details/generalinformation/updategeneralinformation/update-general-info.component';
import { AutoCompleteModule } from 'primeng/primeng';

@NgModule({
    declarations: [
        EntityDetailsComponent,
        AddServiceComponent,
        ContactInformationComponent,
        AddressInformationComponent,
        ClientServicesComponent,
        EntityDetailsClientComponent,
        EntityDetailsOrgComponent,
        EntityDetailsPersonComponent,
        AddAddressComponent,
        GeneralInformationComponent,
        UpdateGeneralInfoComponent,
        AddContactInformationComponent,
        AddAddressComponent,
        EditServicesDescriptionComponent,
    ],
    imports: [
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBw6zrtGzSpNfaPR1BOfMnqUnH6cONDyLk',
            libraries: ['places']
        }),
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        EditorModule,
        AutoCompleteModule,
        CommonPipesModule
    ],
    providers: [
        EntityDetailsService,
        ClientServicesService,
        ContactService,
        AddressInformationService
    ],
    entryComponents: [
        AddServiceComponent,
        ClientServicesComponent,
        AddContactInformationComponent,
        AddAddressComponent,
        EditServicesDescriptionComponent,
        UpdateGeneralInfoComponent,
    ],
    exports: [
        EntityDetailsComponent,
        AddServiceComponent,
        ClientServicesComponent,
    ]
})

/**
 * Main module for the entity details tab management.
 *
 * @author naveenkiran@vernuso.com (Naveen Kiran)
*/
export class EntityDetailsModule { }



// WEBPACK FOOTER //
// ./src/app/entities/details/entity-details.module.ts